import { NavigateBackLink } from '@exam-center/components';
import { useParams } from '@exam-center/router';
import { Box, PageHeader } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ExamLocationManagementLayout() {
  const { examCenterCode, roomRequestId } = useParams(
    '/:examCenterCode/exam-location/requests/:roomRequestId/computer-info',
  );

  return (
    <>
      <PageHeader
        title='รายละเอียดข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-location/requests/:roomRequestId'
            params={{ examCenterCode, roomRequestId }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <Outlet />
      </Box>
    </>
  );
}
